import { orResolver } from '../../../../util/helpers';

const getSubscriptionPriceAndDate = ({ payment, i18n: { formatPrice, formatDate } }) => ({
    price: formatPrice(payment.nextBilling.price),
    date: formatDate(payment.nextBilling.date),
});

const getLastMonthLeftSubscriptionPriceAndDate = ({ i18n: { formatMessage } }) => ({
    price: formatMessage('subscription.noPriceForNextPayment'),
    date: formatMessage('subscription.noDateForNextPayment'),
});

export const getPriceAndDateByConditions = ({ product, payment, i18n }) => orResolver({ product, payment, i18n })([
    [payment?.nextBilling?.date && payment?.nextBilling?.price, getSubscriptionPriceAndDate],
    [payment?.nextBilling?.lackReason === 'NoMore', getLastMonthLeftSubscriptionPriceAndDate],
    [true, () => ({})],
]);

export const formatDiscount = ({ payment, i18n: { formatPrice } }) => (
    payment?.nextBilling?.price?.discountAmount ? formatPrice({
        amount: payment?.nextBilling?.price?.discountAmount,
        currency: payment?.nextBilling?.price?.currency,
    }) : null
);

export const formatRecurringBilling = ({ payment, product, i18n: { formatPeriod, formatPrice } }) => {
    const price = payment?.recurringBilling?.price || {};
    return price.amount && price.currency && product.billingPeriod
        ? `${formatPrice(price)} / ${formatPeriod(product.billingPeriod)}`
        : null;
};

export const formatCreditBalance = ({ payment, i18n: { formatPrice } }) => {
    const price = payment?.creditBalance || {};
    return price && price.amount && price.currency
        ? formatPrice(price)
        : null;
};
